<template>
  <div class="c-adder">
    <Row :gutter="12">
      <Col span="15">
        <Row v-if="tagger" :gutter="12">
          <tagger @on-add="changeAdd"></tagger>
        </Row>
        <Row :gutter="12">
          <Col span="24">
            <Input
              v-model="keyword"
              :placeholder="placeholder"
              class="c-search-input"
              search
              enter-button
              @on-search="search"
              @on-enter="search"
            />
          </Col>
          <Col span="24" style="margin-top: 6px">
            <Spin size="large" fix v-if="loading" />
            <Table
              ref="selection"
              height="282"
              class="c-adder-table"
              :columns="columns"
              :data="data"
              @on-select-cancel="cancelSelection"
              @on-selection-change="changeSelection"
              @on-select-all="changeSelection"
            />
          </Col>
        </Row>
      </Col>
      <Col span="6" offset="1">
        <div v-if="Boolean(lenState)" class="c-select">
          <div class="c-select-head">
            <span class="c-head-title">
              已选
              <ins v-if="maxtotal">（{{ lenState }}/{{ maxtotal }}）</ins>
            </span>
            <span class="c-head-clear" @click="handleClear">清空全部</span>
          </div>
          <div class="c-select-content">
            <div v-for="(item, id) in result" :key="id" class="c-pop-tip">
              <Tag :name="item.name" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import Tagger from './tagger.vue'
export default {
  name: 'adder',
  components: { Tagger },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean
    },
    columns: {
      type: Array
    },
    maxtotal: {
      type: Number,
      default() {
        return 0
      }
    },
    tagger: {
      type: Boolean,
      default() {
        return false
      }
    },
    placeholder: {
      type: String
    }
  },
  computed: {
    result: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    lenState() {
      return isArray(this.value) && this.value.length
    },
    length() {
      return this.data && this.data.length
    }
  },
  methods: {
    search() {
      this.disableMore = false
      this.$emit('on-search', this.keyword)
    },
    handleClear() {
      this.$emit('input', [])
    },
    handleClose(event, name) {
      const data = JSON.parse(JSON.stringify(this.value))
      const index = data.findIndex((ret) => ret.name === name)
      data.splice(index, 1)
      this.$emit('input', data)
    },
    changeSelection(selection) {
      this.$emit('on-select', selection)
    },
    cancelSelection(selection, row) {
      this.$emit('on-delete', [row])
    },
    changeAdd(tags) {
      this.$emit('on-select', tags)
    },
    watchSelection(list) {
      if (!isArray(list)) return
      this.data.forEach((ret) => {
        const check = list.findIndex((met) => ret.name === met.name)
        this.$set(ret, '_checked', check > -1)
      })
    },
    watchDisabled(list, disable = true) {
      if (!isArray(list)) return
      this.data.forEach((ret) => {
        const check = list.findIndex((met) => ret.name === met.name)
        this.$set(ret, '_disabled', disable ? check === -1 : disable)
      })
    }
  },
  watch: {
    value: {
      handler(nVal) {
        if (isArray(nVal)) this.watchSelection(nVal)
        if (isArray(this.value) && this.lenState >= this.maxtotal) {
          this.watchDisabled(this.value)
        } else {
          this.watchDisabled(this.value, false)
        }
      },
      deep: true
    },
    loading(nVal) {
      if (!nVal) this.watchSelection(this.value)
      if (isArray(this.value) && this.lenState >= this.maxtotal && !nVal) this.watchDisabled(this.value)
    },
    lenState(nVal) {
      if (nVal > 10) this.$emit('input', this.value.slice(0, 10))
    }
  },
  data() {
    return {
      keyword: '',
      disableMore: null
    }
  }
}
</script>
<style lang='scss'>
.c-adder {
  min-height: 286px;
  position: relative;
}

.c-adder-table th {
  height: 28px;
}

.c-adder-table td {
  height: 32px;
}

.c-select {
  min-width: 224px;
  background-color: #fff;
  border: solid 1px #dee4f5;

  .c-select-head {
    padding: 0 12px;
    height: 34px;
    font-size: 14px;
    color: #333;
    border-bottom: solid 1px #dee4f5;
    background-color: #fafbfe;

    .c-head-title,
    .c-head-clear {
      height: 34px;
      line-height: 34px;
      vertical-align: middle;
    }

    .c-head-clear {
      color: #598fe6;
      float: right;
      cursor: pointer;
      margin-left: 12px;
    }
  }

  .c-select-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: 287px;
    padding-bottom: 8px;
  }

  .c-pop-tip {
    width: 100%;
  }

  .c-tag-item {
    margin: 8px 8px 0;
    padding: 2px 6px;
    display: block;
    font-size: 14px;
    height: 28px;
    user-select: none;
  }
}
</style>
